export type CalloutVariant = 'outlined' | 'subtle';
export type CalloutType = 'success' | 'info' | 'warning' | 'error' | 'promotional';

export const isSubtle = ( variant: CalloutVariant ): boolean => variant === 'subtle';
